import { NgModule } from '@angular/core';
import { CustomStorefrontComponent } from './custom-storefront.component';

@NgModule({
  exports: [CustomStorefrontComponent],
  imports: [CustomStorefrontComponent]
})
export class CustomStorefrontModule {}
